import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import avatar5 from '../../assets/img/avatar_5.svg';
import ProjectDropdown from '../../components/CommonFilter/ProjectDropdown';
import AddSingleMemberDropdown from '../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import FilterDropDownStyle from '../../components/DropdownStyle/FilterDropDownStyle';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../components/Search/SearchWithButton';
import DatePicker from '../../components/SingleDatePicker/SingleDatePicker';
import { ButtonIcon, ColoredButtonWithIcon } from '../../styledComponents/buttons';
import tickIcon from '../../assets/img/icons/tick_2.svg';

import {
  CommonGrid,
  FilterLabel,
  InputField,
  InputWithLabelSection,
} from '../../styledComponents/common';
import { FilterContainer } from '../../styledComponents/tasks';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';

const MembersFilter = props => {
  const { t } = useTranslation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedEmployeeType, setSelectedEmployeeType] = useState(null);
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState(
    [
      {
        label: t('remote_user'),
        value: 'remote',
      },
      {
        label: t('office_user'),
        value: 'office',
      },
      {
        label: t('mashaer_user'),
        value: 'mashaer',
      },
    ]
  );
  const roleOptions = [
    {
      label: t('all_roles'),
      value: null,
    },
    {
      label: 'Admin',
      value: 'admin',
    },
    {
      label: 'GM',
      value: 'gm',
    },
    {
      label: 'AGM',
      value: 'agm',
    },
    {
      label: 'Supervisor',
      value: 'supervisor',
    },
    {
      label: 'Employee',
      value: 'employee',
    },
  ];

  const {
    getOfficesShortList,
    officesShortList,
    selectedOffice,
    selectOffice,
    handleSearchByName,
    handleClearSearch,
    searchTerm,
    onSearchTermChange,
    userCodeSearchTerm,
    onUserCodeSearchTermChange,
    handleSearchByUserCode,
    handleClearUserCodeSearch,
    selectedRole,
    onRoleChange,
    selectedMembers,
    selectedAllMembers,
    bulkUpdateEmployeeType,
    bulkUpdateEmployeeTypeLoading,
    requestUpdateEmployeeType,
    requestUpdateEmployeeTypeLoading,
  } = props;

  useEffect(() => {
    getOfficesShortList();
  }, []);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  const handleApplyEmployeeTypeChange = () => {
    if (!selectedEmployeeType) return;

    console.log(selectedMembers);
    // based on  roles of the user, we will update the employee type
    if (localStorage.getItem('user_role') === 'admin') {
      let payload = {
        update_type: selectedAllMembers ? "all" : "partial",
      }

      if (!selectedAllMembers) {
        payload.user_updates = []
        selectedMembers.forEach(member => {
          payload.user_updates.push({
            user_id: member.id,
            fields: {
              user_type: selectedEmployeeType.value
            }
          })
        })
      }
      else {
        payload.fields = {
          user_type: selectedEmployeeType.value
        }
      }

      // Call the action with the payload
      bulkUpdateEmployeeType(payload);
    }
    else if (['gm', 'agm'].includes(localStorage.getItem('user_role'))) {
      let payload = [
      ]
      for (let member of selectedMembers) {
        payload.push({
          user_id: member.id,
          first_name: member.first_name,
          last_name: member.last_name,
          email: member.email,
          role: member.role,
          office_id: member.office.id,
          user_type: selectedEmployeeType.value
        })
      }
      requestUpdateEmployeeType(payload);
    }
  };

  return (
    <FilterContainer
      columns={
        localStorage.getItem('user_role') === 'admin'
          ? `160px 340px 250px 160px ${selectedMembers?.length > 0 && selectedEmployeeType ? '400px' : '160px'}`
          : '340px 250px 360px 160px'
      }
      gap="15px"
    >
      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('office')}</FilterLabel>

          <Select
            isSearchable
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Office..."
            onChange={e => {
              selectOffice(e);
            }}
            styles={CreateProjectDropdown()}
            // clearable
            filterOption={filterOption}
          />
        </InputWithLabelSection>
      )}
      <SearchWithButton
        itemName={""}
        label={t('search_member')}
        searchTermName={`${t('member_name')} ${t('or_email')}`}
        searchInput={searchTerm}
        onInputChange={onSearchTermChange}
        handleSearch={handleSearchByName}
        handleClearSearch={handleClearSearch}
        fontSize="12.5px"
      />
      <SearchWithButton
        itemName={""}
        label={t('search_member')}
        searchTermName={t('user_id')}
        searchInput={userCodeSearchTerm}
        onInputChange={onUserCodeSearchTermChange}
        handleSearch={handleSearchByUserCode}
        handleClearSearch={handleClearUserCodeSearch}
        fontSize="12.5px"
      />
      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('role')}</FilterLabel>

          <Select
            isSearchable
            value={selectedRole}
            options={roleOptions}
            placeholder={t('select_role')}
            onChange={e => {
              onRoleChange(e);
            }}
            styles={CreateProjectDropdown()}
          />
        </InputWithLabelSection>
      )}

      {localStorage.getItem('user_role') === 'admin' && selectedMembers.length > 0 && (
        <InputWithLabelSection>
          <FilterLabel>{t('employee_type')}</FilterLabel>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Select
              isSearchable
              value={selectedEmployeeType}
              options={employeeTypeOptions}
              placeholder={t('select_employee_type')}
              onChange={e => {
                setSelectedEmployeeType(e);
              }}
              styles={CreateProjectDropdown()}
            />
            {localStorage.getItem('user_role') === 'admin' && selectedMembers?.length > 0 && selectedEmployeeType && (
              <ColoredButtonWithIcon
                onClick={handleApplyEmployeeTypeChange}
                disabled={bulkUpdateEmployeeTypeLoading}
              >
                {bulkUpdateEmployeeTypeLoading || requestUpdateEmployeeTypeLoading ? (
                  <ButtonTextLoader loadingText={t('requesting')} fontSize="13px" />
                ) : (
                  <>
                    <ButtonIcon src={tickIcon} />
                    {t('request_to_change_type')}
                  </>
                )}
              </ColoredButtonWithIcon>
            )}
          </div>
        </InputWithLabelSection>
      )}
    </FilterContainer>
  );
};

export default MembersFilter;
